import { render, staticRenderFns } from "./MenuAdminicular.vue?vue&type=template&id=729a9fa0&scoped=true"
import script from "./MenuAdminicular.vue?vue&type=script&lang=js"
export * from "./MenuAdminicular.vue?vue&type=script&lang=js"
import style0 from "./MenuAdminicular.vue?vue&type=style&index=0&id=729a9fa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729a9fa0",
  null
  
)

export default component.exports